
export type Language = 'pt' | 'en' | 'es';

export const translations = {
  pt: {
    heroTitle: "Sua agenda no piloto automático com IA",
    heroSub: "A plataforma completa para profissionais autônomos reduzirem faltas em até 42% e automatizarem agendamentos via WhatsApp.",
    startFree: "Começar Teste Grátis",
    login: "Entrar",
    feature1Title: "IA de Retenção",
    feature1Desc: "Nossa IA analisa o comportamento dos seus clientes e envia lembretes persuasivos no momento exato.",
    feature2Title: "Link de Agendamento",
    feature2Desc: "Um link profissional para seus clientes agendarem sem você precisar parar o que está fazendo.",
    feature3Title: "Financeiro Integrado",
    feature3Desc: "Controle seus ganhos, sessões realizadas e pendências em um painel simplificado.",
    trustedBy: "Confiado por mais de 5.000 profissionais",
    dashboard: "Painel",
    calendar: "Agenda",
    publicLink: "Link Público",
    pricing: "Planos",
    settings: "Ajustes",
    hello: "Olá",
    activeAutomation: "Automação de WhatsApp ativa",
    reductionRate: "Reduzindo faltas em 42%",
    upgrade: "UPGRADE PREMIUM",
    revenue: "Faturamento",
    confirmation: "Confirmação",
    atRisk: "Em Risco",
    savings: "Economia",
    daysOfUse: "Dias de Uso",
    aiRetention: "IA de Retenção",
    conversionTip: "Dica de Conversão",
    whatsappScript: "Script WhatsApp (Auto)",
    automationMetrics: "Métricas de Automação",
    attentionNeeded: "Atenção Necessária",
    allConfirmed: "Todos os clientes confirmados!",
    newAppointment: "NOVO AGENDAMENTO",
    chooseTime: "Escolha seu horário",
    step: "Passo",
    next: "Próximo Passo",
    back: "Voltar",
    finish: "Finalizar Agendamento",
    success: "Agendado!",
    whatsappInvite: "Um convite foi enviado para seu WhatsApp.",
    yourData: "Seus Dados",
    name: "Nome Completo",
    phone: "Seu WhatsApp",
    sessionValue: "Valor da Sessão",
    profession: "Especialidade",
    save: "Salvar Configurações",
    currency: "R$",
    freeTrial: "7 Dias Grátis",
    cancelAnytime: "Cancele a qualquer momento",
    startTrial: "Começar Teste Grátis",
    noChargeToday: "Sem cobrança hoje",
    notes: "Notas Rápidas",
    notesPlaceholder: "Digite algo importante...",
    clearNotes: "Limpar",
    removeNotes: "Remover Bloco",
    howItWorks: "Como Funciona",
    testimonials: "Depoimentos",
    faq: "Dúvidas Frequentes",
    downloadApp: "Baixar Aplicativo",
    downloadDesc: "Leve o AgendaAuto para onde quiser. Instale em seu celular ou desktop para acesso instantâneo.",
    installPwa: "Instalar no Celular",
    desktopApp: "Versão Desktop",
    step1: "Crie seu perfil",
    step1Desc: "Configure sua especialidade e horários em segundos.",
    step2: "Compartilhe seu link",
    step2Desc: "Seus clientes agendam sozinhos, sem burocracia.",
    step3: "IA faz o resto",
    step3Desc: "Lembretes automáticos e insights para seu negócio crescer.",
    faq1Q: "Funciona para qualquer profissão?",
    faq1A: "Sim! O AgendaAuto foi desenhado para médicos, psicólogos, personal trainers, manicures e qualquer profissional que precise gerir horários.",
    faq2Q: "Preciso baixar algo?",
    faq2A: "Não necessariamente. Você pode usar pelo navegador ou instalar como um aplicativo (PWA) para ter uma experiência nativa.",
    faq3Q: "Como a IA ajuda?",
    faq3A: "Nossa IA analisa padrões de cancelamento e envia mensagens persuasivas para garantir que o cliente compareça.",
    affiliate: "Afiliados",
    affiliateTitle: "Programa de Parceiros",
    affiliateSub: "Ganhe 40% de comissão recorrente por cada venda indicada.",
    affiliateLink: "Seu Link de Afiliado",
    affiliateStats: "Suas Estatísticas",
    affiliateEarnings: "Ganhos Totais",
    affiliateSales: "Vendas Realizadas",
    affiliateClicks: "Cliques no Link",
    affiliateCommission: "Comissão (40%)",
    copyLink: "Copiar Link",
    linkCopied: "Link Copiado!",
    payoutTitle: "Como recebo minha comissão?",
    payoutDesc: "Os pagamentos são realizados mensalmente via PIX ou PayPal, sempre que você atingir o saldo mínimo de R$ 100,00.",
    payoutMethod: "Método de Recebimento",
    payoutKey: "Chave PIX ou E-mail PayPal",
    payoutStatus: "Status do Pagamento",
    payoutNext: "Próximo ciclo: Dia 05",
    minPayout: "Saldo mínimo para saque: R$ 100,00",
    calendarSync: "Sincronização de Agenda",
    connectGoogle: "Conectar Google Agenda",
    connectOutlook: "Conectar Outlook Calendar",
    syncSuccess: "Agenda conectada com sucesso!",
    syncDesc: "Sincronize seus agendamentos automaticamente com suas agendas pessoais.",
    privacy: "Política de Privacidade",
    terms: "Termos de Uso",
    privacyText: "Sua privacidade é importante para nós. Coletamos e usamos seus dados apenas para fornecer e melhorar o AgendaAuto. Não compartilhamos informações pessoais com terceiros, exceto quando exigido por lei.",
    termsText: "Ao usar o AgendaAuto, você concorda em cumprir estes termos de serviço. O aplicativo é fornecido 'como está' e não nos responsabilizamos por perdas decorrentes do uso inadequado da plataforma.",
  },
  en: {
    heroTitle: "Your schedule on autopilot with AI",
    heroSub: "The complete platform for independent professionals to reduce no-shows by up to 42% and automate bookings via WhatsApp.",
    startFree: "Start Free Trial",
    login: "Login",
    feature1Title: "Retention AI",
    feature1Desc: "Our AI analyzes client behavior and sends persuasive reminders at the perfect time.",
    feature2Title: "Booking Link",
    feature2Desc: "A professional link for your clients to book without you having to stop what you're doing.",
    feature3Title: "Integrated Finance",
    feature3Desc: "Track your earnings, completed sessions, and pendings in a simplified dashboard.",
    trustedBy: "Trusted by over 5,000 professionals",
    dashboard: "Dashboard",
    calendar: "Calendar",
    publicLink: "Public Link",
    pricing: "Pricing",
    settings: "Settings",
    hello: "Hello",
    activeAutomation: "WhatsApp automation active",
    reductionRate: "Reducing no-shows by 42%",
    upgrade: "UPGRADE PREMIUM",
    revenue: "Revenue",
    confirmation: "Confirmation",
    atRisk: "At Risk",
    savings: "Savings",
    daysOfUse: "Days of Use",
    aiRetention: "Retention AI",
    conversionTip: "Conversion Tip",
    whatsappScript: "WhatsApp Script (Auto)",
    automationMetrics: "Automation Metrics",
    attentionNeeded: "Attention Needed",
    allConfirmed: "All clients confirmed!",
    newAppointment: "NEW APPOINTMENT",
    chooseTime: "Choose your time",
    step: "Step",
    next: "Next Step",
    back: "Back",
    finish: "Finish Booking",
    success: "Booked!",
    whatsappInvite: "An invite was sent to your WhatsApp.",
    yourData: "Your Info",
    name: "Full Name",
    phone: "WhatsApp Number",
    sessionValue: "Session Value",
    profession: "Specialty",
    save: "Save Settings",
    currency: "$",
    freeTrial: "7 Days Free",
    cancelAnytime: "Cancel anytime",
    startTrial: "Start Free Trial",
    noChargeToday: "No charge today",
    notes: "Quick Notes",
    notesPlaceholder: "Type something important...",
    clearNotes: "Clear",
    removeNotes: "Remove Block",
    howItWorks: "How It Works",
    testimonials: "Testimonials",
    faq: "FAQ",
    downloadApp: "Download App",
    downloadDesc: "Take AgendaAuto wherever you go. Install on your phone or desktop for instant access.",
    installPwa: "Install on Mobile",
    desktopApp: "Desktop Version",
    step1: "Create your profile",
    step1Desc: "Set up your specialty and hours in seconds.",
    step2: "Share your link",
    step2Desc: "Your clients book themselves, no hassle.",
    step3: "AI does the rest",
    step3Desc: "Automatic reminders and insights to grow your business.",
    faq1Q: "Does it work for any profession?",
    faq1A: "Yes! AgendaAuto is designed for doctors, psychologists, personal trainers, manicurists, and any professional who needs to manage schedules.",
    faq2Q: "Do I need to download anything?",
    faq2A: "Not necessarily. You can use it via browser or install it as an app (PWA) for a native experience.",
    faq3Q: "How does AI help?",
    faq3A: "Our AI analyzes cancellation patterns and sends persuasive messages to ensure the client shows up.",
    affiliate: "Affiliates",
    affiliateTitle: "Partner Program",
    affiliateSub: "Earn 40% recurring commission for each referred sale.",
    affiliateLink: "Your Affiliate Link",
    affiliateStats: "Your Stats",
    affiliateEarnings: "Total Earnings",
    affiliateSales: "Sales Made",
    affiliateClicks: "Link Clicks",
    affiliateCommission: "Commission (40%)",
    copyLink: "Copy Link",
    linkCopied: "Link Copied!",
    payoutTitle: "How do I receive my commission?",
    payoutDesc: "Payments are made monthly via PayPal or Bank Transfer, whenever you reach the minimum balance of $20.00.",
    payoutMethod: "Payout Method",
    payoutKey: "PayPal Email or Bank Info",
    payoutStatus: "Payout Status",
    payoutNext: "Next cycle: Day 05",
    minPayout: "Minimum withdrawal balance: $20.00",
    calendarSync: "Calendar Sync",
    connectGoogle: "Connect Google Calendar",
    connectOutlook: "Connect Outlook Calendar",
    syncSuccess: "Calendar connected successfully!",
    syncDesc: "Automatically sync your appointments with your personal calendars.",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    privacyText: "Your privacy is important to us. We collect and use your data only to provide and improve AgendaAuto. We do not share personal information with third parties except as required by law.",
    termsText: "By using AgendaAuto, you agree to abide by these terms of service. The app is provided 'as is' and we are not liable for losses resulting from improper use of the platform.",
  },
  es: {
    heroTitle: "Tu agenda en piloto automático con IA",
    heroSub: "La plataforma completa para que profesionales independientes reduzcan inasistencias hasta en un 42% y automatizen citas por WhatsApp.",
    startFree: "Empezar Prueba Gratis",
    login: "Entrar",
    feature1Title: "IA de Retención",
    feature1Desc: "Nuestra IA analiza el comportamiento de tus clientes y envía recordatorios persuasivos en el momento exacto.",
    feature2Title: "Link de Citas",
    feature2Desc: "Un link profesional para que tus clientes reserven sin que tengas que parar lo que estás haciendo.",
    feature3Title: "Finanzas Integradas",
    feature3Desc: "Controla tus ganancias, sesiones realizadas y pendientes en un panel simplificado.",
    trustedBy: "Confiado por más de 5,000 profesionales",
    dashboard: "Panel",
    calendar: "Agenda",
    publicLink: "Link Público",
    pricing: "Planes",
    settings: "Ajustes",
    hello: "Hola",
    activeAutomation: "Automatización de WhatsApp activa",
    reductionRate: "Reduciendo inasistencias en 42%",
    upgrade: "MEJORAR PLAN",
    revenue: "Facturación",
    confirmation: "Confirmación",
    atRisk: "En Riesgo",
    savings: "Ahorro",
    aiRetention: "IA de Retención",
    conversionTip: "Consejo de Conversión",
    whatsappScript: "Script WhatsApp (Auto)",
    automationMetrics: "Métricas de Automatización",
    attentionNeeded: "Atención Necessaria",
    allConfirmed: "¡Todos os clientes confirmados!",
    newAppointment: "NUEVA CITA",
    chooseTime: "Elija su horario",
    step: "Paso",
    next: "Próximo Paso",
    back: "Volver",
    finish: "Finalizar Cita",
    success: "¡Reservado!",
    whatsappInvite: "Se ha enviado una invitación a tu WhatsApp.",
    yourData: "Tus Datos",
    name: "Nombre Completo",
    phone: "Tu WhatsApp",
    sessionValue: "Valor de Sesión",
    profession: "Especialidad",
    save: "Guardar Ajustes",
    currency: "€",
    freeTrial: "7 Días Gratis",
    cancelAnytime: "Cancela en cualquier momento",
    startTrial: "Empezar Prueba Gratis",
    noChargeToday: "Sin cargos hoy",
    notes: "Notas Rápidas",
    notesPlaceholder: "Escribe algo importante...",
    clearNotes: "Limpiar",
    removeNotes: "Eliminar Bloque",
    howItWorks: "Cómo Funciona",
    testimonials: "Testimonios",
    faq: "Preguntas Frequentes",
    downloadApp: "Descargar Aplicación",
    downloadDesc: "Lleva AgendaAuto a donde quieras. Instala en tu móvil o escritorio para acceso instantáneo.",
    installPwa: "Instalar en el Móvil",
    desktopApp: "Versión de Escritorio",
    step1: "Crea tu perfil",
    step1Desc: "Configura tu especialidad y horarios em segundos.",
    step2: "Comparte tu enlace",
    step2Desc: "Tus clientes reservan solos, sin burocracia.",
    step3: "La IA hace el resto",
    step3Desc: "Recordatorios automáticos e insights para que tu negocio crezca.",
    faq1Q: "¿Funciona para cualquier profesión?",
    faq1A: "¡Sí! AgendaAuto está diseñado para médicos, psicólogos, entrenadores personales, manicuras y cualquier profesional que necesite gestionar horarios.",
    faq2Q: "¿Necesito descargar algo?",
    faq2A: "No necesariamente. Puedes usarlo a través del navegador o instalarlo como una aplicación (PWA) para una experiencia nativa.",
    faq3Q: "¿Cómo ayuda la IA?",
    faq3A: "Nuestra IA analiza patrones de cancelación y envía mensajes persuasivos para asegurar que el cliente asista.",
    affiliate: "Afiliados",
    affiliateTitle: "Programa de Socios",
    affiliateSub: "Gana un 40% de comisión recurrente por cada venta referida.",
    affiliateLink: "Tu Enlace de Afiliado",
    affiliateStats: "Tus Estadísticas",
    affiliateEarnings: "Ganancias Totales",
    affiliateSales: "Ventas Realizadas",
    affiliateClicks: "Clics en el Enlace",
    affiliateCommission: "Comisión (40%)",
    copyLink: "Copiar Enlace",
    linkCopied: "¡Enlace Copiado!",
    payoutTitle: "¿Cómo recibo mi comisión?",
    payoutDesc: "Los pagos se realizan mensualmente a través de PayPal o Transferência, siempre que alcances el saldo mínimo de 20,00 €.",
    payoutMethod: "Método de Pago",
    payoutKey: "Email de PayPal o Info Bancaria",
    payoutStatus: "Estado del Pago",
    payoutNext: "Próximo ciclo: Día 05",
    minPayout: "Saldo mínimo de retiro: 20,00 €",
    calendarSync: "Sincronización de Calendario",
    connectGoogle: "Conectar Google Calendar",
    connectOutlook: "Conectar Outlook Calendar",
    syncSuccess: "¡Calendario conectado con éxito!",
    syncDesc: "Sincroniza tus citas automáticamente com tus calendarios personales.",
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    privacyText: "Su privacidad es importante para nosotros. Recopilamos y usamos seus datos solo para fornecer e mejorar o AgendaAuto. No compartimos información personal com terceros, exceto quando exigido por lei.",
    termsText: "Al usar o AgendaAuto, usted concorda em cumprir estes termos de serviço. La aplicación se fornece 'como está' e não nos responsabilizamos por perdas decorrentes del uso inadequado de la plataforma.",
  }
};
